import React, { useState } from 'react';
import './About.css';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import logo from '../../assets/images/logo1.png'; 

const About = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [result, setResult] = useState("");

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setResult("");
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);
    formData.append("access_key", "68f8c92b-95f6-4539-bca9-456711228405");
    formData.append("subject", "New Site Visit Scheduled - About Section");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });
    const data = await response.json();
    if (data.success) {
      setResult("Request Sent Successfully!");
      event.target.reset();
      setTimeout(() => closeModal(), 2500);
    } else {
      setResult(data.message);
    }
  };

  // Zoom Animation Settings
  const zoomInVariants = {
    hidden: { opacity: 0, scale: 0.85 }, // Halka chota (Zoom-out state)
    visible: { 
      opacity: 1, 
      scale: 1, 
      transition: { 
        duration: 0.6, 
        ease: [0.16, 1, 0.3, 1] // Smooth ease-out
      } 
    }
  };

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        
        {/* Left Content Side - Zoom In */}
        <motion.div 
          className="about-content"
          variants={zoomInVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }} // Har baar chalega
        >
          <h4 className="about-subtitle">Sentosa Era</h4>
          <h2 className="about-title">At. Moshi, PCMC Pune</h2>
          <div className="about-underline"></div>
          
          <p className="about-text">
            Sentosa Era is a premium residential development in <strong>Moshi, Pimpri-Chinchwad (PCMC)</strong> by <strong>Sentosa Developers</strong>, created for those who value elegance, comfort, and modern living.
          </p>
          
          <p className="about-text">
            The <strong>14-storey tower</strong> features well-ventilated residences with stylish interiors. With 20+ modern lifestyle amenities, residents enjoy a balanced environment.
          </p>

          <button className="schedule-btn" onClick={openModal}>Schedule Visit</button>
        </motion.div>

        {/* Right Image Side - Zoom In (with slight delay) */}
        <motion.div 
          className="about-image-wrapper"
          variants={zoomInVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }} // Har baar chalega
        >
          <div className="image-border-box"></div>
          <img 
            src="https://images.unsplash.com/photo-1758448511487-15f69dd6107b?q=80&w=580&auto=format&fit=crop" 
            alt="Sentosa Era Building" 
            className="about-img"
          />
        </motion.div>
      </div>

      {/* --- FORM MODAL --- */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            <div className="modal-content">
              <div className="modal-logo"><img src={logo} alt="Logo" /></div>
              <h2 className="enquire-title">Enquire Now</h2>
              <form className="modal-form" onSubmit={onSubmit}>
                <input type="text" name="first_name" placeholder="First Name" required />
                <input type="text" name="last_name" placeholder="Last Name" required />
                <input type="email" name="email" placeholder="Email Id" required />
                <input type="tel" name="mobile" placeholder="Mobile No." required />
                <div className="checkbox-container">
                  <input type="checkbox" id="about-consent" name="consent" required />
                  <label htmlFor="about-consent">I authorize SMS, Calls, RCS, WhatsApp.</label>
                </div>
                <button type="submit" className="modal-submit-btn">
                  SUBMIT NOW <FaArrowRight style={{marginLeft: '8px'}} />
                </button>
              </form>
              {result && <p className="form-status">{result}</p>}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default About;